import { useApi } from './queryUtils';
import { createFetcher } from './createFetcher';
import type { NetworksApiResponse } from '@/types';

/**
 * A hook to fetch the users networks
 * @param userId - The users id
 * @param isImpersonating - Whether the user is impersonating another user
 * @returns The users networks
 */
export const useUserNetworksQuery = (userId?: string, isImpersonating?: boolean) => {
  const enabled = !!userId && userId !== '';
  return useApi(
    ['user-networks', userId, isImpersonating],
    createFetcher<NetworksApiResponse>(`/v2/users/${userId}/networks`),
    { enabled }
  );
};
